module.exports = __webpack_public_path__ + "img/green_logo.78469921.svg";